import React from "react";
import {
    XLazyColumn,
    XLazyDataTable, XSearchBrowseProps
} from "@michalrakus/x-react-web-lib/XLazyDataTable";
import {StatForm} from "./StatForm";

export const StatBrowse = (props: XSearchBrowseProps) => {

    return (
        <div>
            <XLazyDataTable entity="Stat" label="Štáty" rows={30}
                            sortField="nazov"
                            editForm={<StatForm/>} removeRow={true}
                            searchBrowseParams={props.searchBrowseParams}>
                <XLazyColumn field="id" header="ID" width="5rem"/>
                <XLazyColumn field="nazov" header="Názov" width="20rem"/>
            </XLazyDataTable>
        </div>
    );
}
